import Hero from "./pages/hero/Hero";
import Works from "./pages/works/Works";
import Experiments from "./pages/experiments/Experiments";
import About from "./pages/about/About";
import NavBar from "./components/navbar/NavBar";

function Home() {
    return (
        <main style={{ display: "flex", flexDirection: "column", gap: "60px" }}>
            <Hero />
            <Works />
            <NavBar />
            <Experiments />
            <About />
        </main>
    );
}

export default Home;